<template>
  <v-container class="pa-0">
    <v-row>
      <v-col cols="12" class=" pt-2 pb-0" style="display: flex; justify-content: end;">
        <v-btn color="primary" text @click="getFile()" :disabled="list.length == 0">
          <v-icon small>fa-download</v-icon>
          <legend>Exportar Resultado</legend>
        </v-btn>
      </v-col>
      <v-row 
        v-if="list.length > 0"
        class="ma-3 pl-4 pr-1" 
        style="background-color: #d1dcea">
        <v-col cols="2" class="pa-4">
          <div class="px-0 pt-1">
            <b class="pr-2">TOTAIS</b>
          </div>
        </v-col>
        <v-col cols="10" class="pa-0">
          <v-row class="ma-2 pt-1" style="justify-content: end;">
            <v-spacer/>
              <v-col class="text-list text-right px-0 py-1" style="margin-right: 5px; max-width:13.5%">
                <small>Valor previsto (R$)</small><br />
                <b><span>{{ totais.total_vl_prev_faturamento | formatPrice}}</span></b>
              </v-col>
              <v-col class="text-list text-right px-0 py-1" style="max-width:13.5%">
                <small>Valor transmitido (R$)</small><br />
                <b><span style="color: rgb(50, 184, 139)">{{ totais.total_vl_faturamento | formatPrice}}</span></b>
              </v-col>
              <v-col class="text-list text-right px-0 py-1" style="max-width:13.5%">
                <small>Perc. transmitido (%)</small><br />
                <b><span>{{ totais.total_porcem_faturado | formatPrice}}%</span></b>
              </v-col>              
          </v-row>
        </v-col>
      </v-row>      
      <v-col class="py-1" cols="12" sm="12" md="12">
        <v-data-table
          :headers="headers"
          :items="list"
          hide-default-footer
          :items-per-page="pagination.limit"
          dense
        >
          <template v-slot:item="props">
            <tr>
              <td class="font-list pa-2">{{ props.item.prest_nome }}</td>
              <td class="font-list pa-2">{{ props.item.oper_nome }}</td>
              <td class="text-right font-list pa-2">{{ props.item.vl_prev_faturamento | formatPrice}}</td>
              <td class="text-right font-list pa-2">{{ props.item.vl_faturamento | formatPrice}}</td>
              <td class="text-center font-list pa-2">{{ props.item.perc_diferenca }}%</td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
      <v-col class="text-center" cols="12">
          <v-pagination class="no-box-shadow" v-model="pagination.current_page" :length="pagination.total_pages" @input="getList"></v-pagination>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      headers: [
        { text: "Prestador", align: "start", value: "prestador", sortable: false },
        { text: "Operadora.", value: "operadora.", sortable: false },
        { text: "Total previsto (R$) ", value: "val_previsto", sortable: false },
        { text: "Total transmitido (R$)", value: "val_transmitido", sortable: false },
        { text: "Perc. Transmitido (%)", value: "perc_diferenca", sortable: false },
      ],
    };
  },
  filters: {
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }
  },
  watch: {
    dados(data) {
      this.list = data.dados
      this.pageCount = data.total_pages
      
    }
  },
  props: {
    list: Array,
    pagination: Object,
    getList: Function,
    getFile: Function,
    totais: Object
  },
};
</script>

<style>
.no-box-shadow, .no-box-shadow *{
  box-shadow: 0 0 0 0!important;
}
</style>
